import { useState } from "react";
import { Link2, Check } from "lucide-react";

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor" aria-hidden="true">
    <path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.3-.4.2-.4.8-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.7 11.8 11.8 0 0 0 4.5 4c1.7.7 2.3.8 3.2.6a2.7 2.7 0 0 0 1.8-1.3 2.2 2.2 0 0 0 .2-1.3c-.1-.1-.2-.2-.5-.3z" />
  </svg>
);

const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor" aria-hidden="true">
    <path d="M13.5 21v-7.5h2.6l.4-3h-3V8.6c0-.9.3-1.5 1.5-1.5h1.6V4.4a21 21 0 0 0-2.3-.1c-2.3 0-3.9 1.4-3.9 4v2.2H7.8v3h2.6V21z" />
  </svg>
);

const cls = "inline-flex items-center gap-2 px-4 py-2 border border-[#303B2D] rounded-sm text-[11px] uppercase tracking-[0.18em] text-[#D3CEC4]/70 hover:border-[#B5A642]/60 hover:text-[#E8DDC7] transition-colors duration-300";

export const ShareBar = ({ slug, title, lang, t }) => {
  const [copied, setCopied] = useState(false);
  const url = `${window.location.origin}/api/journal/share/${slug}${lang === "fr" ? "?lang=fr" : ""}`;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      window.prompt(t("Copy this link", "Copiez ce lien"), url);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2200);
  };
  return (
    <div className="flex flex-wrap items-center gap-3" data-testid="article-share">
      <span className="text-[10px] uppercase tracking-[0.3em] text-[#B5A642]/80 mr-1">{t("Pass it along", "Faites passer")}</span>
      <a data-testid="share-whatsapp" className={cls} target="_blank" rel="noreferrer"
        href={`https://wa.me/?text=${encodeURIComponent(`${title} ${url}`)}`}>
        <WhatsAppIcon /> WhatsApp
      </a>
      <a data-testid="share-facebook" className={cls} target="_blank" rel="noreferrer"
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`}>
        <FacebookIcon /> Facebook
      </a>
      <button data-testid="share-copy-link" onClick={copy} className={cls}>
        {copied ? <Check className="w-4 h-4 text-[#B5A642]" /> : <Link2 className="w-4 h-4" />}
        {copied ? t("Link copied", "Lien copié") : t("Copy link", "Copier le lien")}
      </button>
    </div>
  );
};
